import { useCallback } from "react";
import { useEquimentConfiguration } from "../../../queries/configuration/use-equiment-configuration";
import { useManageMarking } from "../../../queries/tasks/use-manage-marking";
import { Task } from "../../../queries/tasks/use-tasks";
import { MarkingTaskShared } from "./marking-task-shared";
import { useTranslation } from "react-i18next";

export function MarkingTask({ task }: { task?: Task }) {
  const { t } = useTranslation();
  const { config: autoStartConfig } = useEquimentConfiguration(
    "MarkingAutoStart",
    "AppU4DM"
  );
  const { config: autoCompleteConfig } = useEquimentConfiguration(
    "ValidationAutoComplete",
    "AppU4DM"
  );
  const { sendMarkingCommand, isSuccess, isPending, error } =
    useManageMarking();

  const autoStart = autoStartConfig?.PropertyValue?.toLowerCase() === "true";
  const autoComplete =
    autoCompleteConfig?.PropertyValue?.toLowerCase() === "true";

  const startMarking = useCallback(() => {
    if (!task?.Id) return;

    sendMarkingCommand(task.Id);
  }, [sendMarkingCommand, task?.Id]);

  if (!task) return null;

  return (
    <MarkingTaskShared
      task={task}
      autoMark={autoStart}
      startedManually={isSuccess}
      isPending={isPending}
      onMark={startMarking}
      error={error}
      textSlot={autoComplete && <p>{t("task.marking.autoCompleteText")}</p>}
    />
  );
}
